
<template>
    <div class="report-hit-and-missed">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 128.62 82.73" style="enable-background:new 0 0 128.62 82.73;" xml:space="preserve" fill="transparent" :style="{stroke: colors.theme == 'dark' ? '#fff':'#000'}">
            <g>
                <path class="st0" d="M64.25,72.65c-15.39,11.71-37.45,10.53-51.5-3.52c-15.33-15.33-15.33-40.2,0-55.53
                    C26.69-0.34,48.51-1.61,63.88,9.8"/>
                <circle class="st0" cx="87.25" cy="41.37" r="39.27"/>
                <polyline class="st0" points="51.51,23.67 41.22,33.97 30.92,23.67 22.48,32.11 32.78,42.4 22.48,52.7 30.92,61.14 41.22,50.84 51.51,61.14"/>
                <g>
                    <polygon class="st0" points="81.66,64.34 58.81,43.75 67.48,34.12 81.04,46.34 106.38,20.47 115.69,29.47"/>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>

export default {
    data:() => ({colors: ''}),

    created(){
        this.colors = JSON.parse(localStorage.getItem('colors'))
    }
}
</script>

<style lang="scss" scoped>
</style>